
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// Create a new interview candidate
export const createInterviewCandidateAPI = async (candidateData) => {
  try {
    const response = await apiService.post(endpoints.createInterviewCandidate, candidateData);
    return response.data;
  } catch (error) {
    const errorMessage = 
      error.response?.data?.message || 
      error.response?.data?.error ||
      error.response?.data?.msg ||
      error.message ||
      "Failed to create interview candidate";
    
    const customError = new Error(errorMessage);
    customError.response = error.response;
    throw customError;
  }
};

// Get Interview Candidate List
export const getInterviewCandidateListAPI = async (params) => {
  try {
    const queryParams = {
      company_id: params.company_id,
      page: params.page || 1,
      limit: params.limit || 10,
    };
    
    if (params.search && params.search.trim() !== '') {
      queryParams.search = params.search;
    }
    
    const response = await apiService.get(endpoints.getInterviewCandidateList, queryParams);
    console.log("📡 API Response: getInterviewCandidateList", response);
    return response.data;
  } catch (error) {
    console.error("❌ Get Interview Candidate List API Error:", error);
    throw error;
  }
};

// Add or Update Company Quota
export const addOrUpdateCompanyQuotaAPI = async (quotaData) => {
  try {
    console.log("📡 API Call: addOrUpdateCompanyQuota", quotaData);
    console.log("📡 Endpoint:", endpoints.addCompanyQuota);
    
    const response = await apiService.put(endpoints.addCompanyQuota, quotaData);
    
    console.log("📡 API Response: addOrUpdateCompanyQuota", response);
    return response.data;
  } catch (error) {
    console.error("❌ Add/Update Company Quota API Error:", error);
    console.error("❌ Error Details:", error.response?.data);
    throw error;
  }
};

// Cancel an interview candidate
export const cancelInterviewCandidateAPI = async (cancelData) => {
  try {
    console.log("📡 API Call: cancelInterviewCandidate", cancelData);
    const response = await apiService.post(endpoints.cancelInterviewCandidate, cancelData);
    console.log("📡 API Response: cancelInterviewCandidate", response);
    return response.data;
  } catch (error) {
    console.error("❌ Cancel Interview Candidate API Error:", error);
    throw error;
  }
};

// Get Candidate Assessment Link
export const getCandidateAssessmentLinkAPI = async (assessmentData) => {
  try {
    const response = await apiService.post(endpoints.getCandidateAssessmentLink, assessmentData);
    return response.data;
  } catch (error) {
    console.error("❌ Get Candidate Assessment Link API Error:", error);
    console.error("❌ Error Details:", error.response?.data);
    
    const errorMessage = 
      error.response?.data?.message || 
      error.response?.data?.error ||
      error.response?.data?.msg ||
      error.message ||
      "Failed to get candidate assessment link";
    
    const customError = new Error(errorMessage);
    customError.response = error.response;
    throw customError;
  }
};

// Get Candidate Result by Candidate ID
export const getCandidateResultAPI = async (resultData) => {
  try {
    console.log("📡 API Call: getCandidateResult", resultData);
    
    const { company_id, candidate_id } = resultData;
    
    const response = await apiService.get(
      `/interview-candidate/${company_id}/result`,
      { candidate_id }
    );
    
    console.log("📡 API Response: getCandidateResult", response);
    return response.data;
  } catch (error) {
    console.error("❌ Get Candidate Result API Error:", error);
    console.error("❌ Error Details:", error.response?.data);
    
    const errorMessage = 
      error.response?.data?.message || 
      error.response?.data?.error ||
      error.response?.data?.msg ||
      error.message ||
      "Failed to get candidate result";
    
    const customError = new Error(errorMessage);
    customError.response = error.response;
    throw customError;
  }
};
